import React from "react";
import ExaminationInfoCard from "./examinationInfoCard/ExaminationInfoCard";
import ExaminationFilesTab from "./tabs/examinationFilesTab/ExaminationFilesTab";
import InstancesTab from "./tabs/instancesTab/InstancesTab";
import StudentFileProposals from "./tabs/studentFileProposalsTab/StudentFileProposalsTab";
import { Badge, Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../services/CamplaCoreService";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import MarkdownViewerDialog from "../../components/markdownViewerDialog/MarkdownViewerDialog";
import UpdateExaminationDialog from "./dialogs/updateExaminationDialog/UpdateExaminationDialog";
import OpenExamAndAcceptSubmissionsDialog from "./dialogs/openExamAndAcceptSubmissionsDialog/OpenExamAndAcceptSubmissionsDialog";
import StorageService from "../../services/StorageService";
import RunningDownloadDialog from "../../components/dialogs/runningDownloadDialog/RunningDownloadDialog";
import ConfigurationTab from "./tabs/configurationTab/ConfigurationTab";

class SingleExamination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      examination: null,
      apiError: "",
      dialogApiError: "",
      studentFileProposals: [],
      studentFileProposalsIndexMap: new Map(),

      showConfirmationDialog: false,
      confirmationDialogTitle: "",
      confirmationDialogBody: "",
      confirmationDialogRightButtonVariant: "primary",
      confirmationDialogLeftButtonVariant: "secondary",

      runningDownloadDialogShow: false,
      runningDownloadDialogTitle: "",
      runningDownloadDialogProgress: 0,

      showMarkdownViewerDialog: false,
      selectedMarkdownViewerText: null,
      selectedMarkdownViewerTitle: "",

      showUpdateExaminationDialog: false,
      open: false,
    };

    this.fetchData = this.fetchData.bind(this);
    this.registerEventListener = this.registerEventListener.bind(this);
    this.setActionConfirmationState = this.setActionConfirmationState.bind(
      this
    );
    this.handleExport = this.handleExport.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleResume = this.handleResume.bind(this);
    this.handleRetry = this.handleRetry.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDownloadSubmissions = this.handleDownloadSubmissions.bind(this);
    this.handleAdditionalInformation = this.handleAdditionalInformation.bind(
      this
    );
    this.handleUpdateExamination = this.handleUpdateExamination.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleUpdateConfiguration = this.handleUpdateConfiguration.bind(this);
  }


  componentDidMount() {
    try {
      const cachedExamination = StorageService.getReferenceType(
          "singleExamination"
      );
      if (cachedExamination) {
        if (this.props.match.params.id === cachedExamination._id) {
          this.setState({examination: cachedExamination});
        }
      }
    }catch (err){}
    this.fetchData().then(() => this.registerEventListener());
  }

  registerEventListener() {
    CamplaCoreService.addEventListener("SingleExamination", (event) => {
      if (
        event.model === "examinations" &&
        event.action === "update" &&
        this.state.examination &&
        event.object._id === this.state.examination._id
      ) {
        const updatedExamination = Object.assign({}, this.state.examination);
        updatedExamination["status"] = event.object.status;
        StorageService.set("singleExamination", updatedExamination);
        this.setState({ examination: updatedExamination });
      }
      if (
        event.model === "studentFileStorage" &&
        typeof event.object["examinationId"] !== "undefined" &&
        event.object.examinationId === this.state.examination._id
      ) {
        switch (event.action) {
          case "update":
            const idx = this.state.studentFileProposalsIndexMap.get(
              event.object._id
            );
            const clonedFileProposal = Object.assign(
              {},
              this.state.studentFileProposals[idx]
            );
            clonedFileProposal["isAccepted"] = event.object.isAccepted;
            const updatedStudentFileProposals = [
              ...this.state.studentFileProposals,
            ];
            updatedStudentFileProposals[idx] = clonedFileProposal;
            this.setState({
              studentFileProposals: updatedStudentFileProposals,
            });
            break;
          case "create":
            if (this.state.studentFileProposalsIndexMap.has(event.object._id))
              return;
            const studentFileProposals = [
              ...this.state.studentFileProposals,
              event.object,
            ];
            studentFileProposals.sort((a, b) => {
              return new Date(b.updated_at) - new Date(a.updated_at);
            });
            const studentFileProposalsIndexMap = new Map();
            studentFileProposals.forEach((sf, idx) =>
              studentFileProposalsIndexMap.set(sf._id, idx)
            );
            this.setState({
              studentFileProposals: studentFileProposals,
              studentFileProposalsIndexMap: studentFileProposalsIndexMap,
            });
            break;
          case "remove":
            const studentFileProposalsIndexMapRemove = new Map(
              this.state.studentFileProposalsIndexMap
            );
            studentFileProposalsIndexMapRemove.delete(event.object._id);

            const removedStudentFileProposals = this.state.studentFileProposals.filter(
              (sf) => sf._id !== event.object._id
            );
            this.setState({
              studentFileProposals: [...removedStudentFileProposals],
              studentFileProposalsIndexMap: studentFileProposalsIndexMapRemove,
            });
            break;
          default:
            console.error("Invalid action given");
            break;
        }
      }
    });
  }

  async fetchData() {
    try {
      const examination = await CamplaCoreService.getExamination(
        this.props.match.params.id
      );
      const studentFileProposals = await CamplaCoreService.getAllStudentFilesByExamination(
        examination._id
      );
      const studentFileProposalsIndexMap = new Map();
      studentFileProposals.sort((a, b) => {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });
      studentFileProposals.forEach((sf, idx) =>
        studentFileProposalsIndexMap.set(sf._id, idx)
      );
      if (
        typeof this.state.examination?.className !== "undefined" &&
        this.state.examination?.moduleName !== "undefined"
      ) {
        examination["className"] = this.state.examination.className;
        examination["moduleName"] = this.state.examination.moduleName;
      }
      const instanceTemplate = await CamplaCoreService.getInstanceTemplate(
        examination.instanceTemplateId
      );
      const networkProfile = await CamplaCoreService.getNetworkProfile(
        examination.networkProfileId
      );
      const moduleClass = await CamplaCoreService.getModuleClass(
        examination.moduleClassId
      );
      const mModule = await CamplaCoreService.getModule(moduleClass.moduleId);
      const mClass = await CamplaCoreService.getClass(moduleClass.classId);
      examination["instanceTemplate"] = instanceTemplate;
      examination["networkProfile"] = networkProfile;
      examination["className"] = mClass.name;
      examination["moduleName"] = mModule.name;
      StorageService.set("singleExamination", examination);
      this.setState({
        examination: examination,
        studentFileProposals: studentFileProposals,
        studentFileProposalsIndexMap: studentFileProposalsIndexMap,
      });
    } catch (err) {
      await this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  handleOpen() {
    const { t } = this.props;
    this.setState({ open: true });

    this.setActionConfirmationState(
      t("Examinations.ConfirmationDialog.Open.Title"),
      t("Examinations.ConfirmationDialog.Open.Body", {
        examName: this.state.examination.name,
      }),
      async () => {
        try {
          await CamplaCoreService.openExamination(this.state.examination._id);
          this.setState({
            dialogApiError: "",
            showConfirmationDialog: false,
            open: false,
          });
        } catch (err) {
          //Todo: Add correct errors according to documentation
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t
            ),
          });
        }
      },
      "green"
    );
  }

  handleClose() {
    const { t } = this.props;

    this.setActionConfirmationState(
      t("Examinations.ConfirmationDialog.Close.Title"),
      t("Examinations.ConfirmationDialog.Close.Body", {
        examName: this.state.examination.name,
      }),
      async () => {
        try {
          await CamplaCoreService.closeExamination(this.state.examination._id);
          this.setState({ dialogApiError: "", showConfirmationDialog: false });
        } catch (err) {
          //Todo: Add correct errors according to documentation
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t
            ),
          });
        }
      },
      "red"
    );
  }

  handlePause() {
    const { t } = this.props;

    this.setActionConfirmationState(
      t("Examinations.ConfirmationDialog.Pause.Title"),
      t("Examinations.ConfirmationDialog.Pause.Body", {
        examName: this.state.examination.name,
      }),
      async () => {
        try {
          await CamplaCoreService.pauseExamination(this.state.examination._id);
          this.setState({ dialogApiError: "", showConfirmationDialog: false });
        } catch (err) {
          //Todo: Add correct errors according to documentation
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t
            ),
          });
        }
      },
      "green"
    );
  }

  handleResume() {
    const { t } = this.props;

    this.setActionConfirmationState(
      t("Examinations.ConfirmationDialog.Resume.Title"),
      t("Examinations.ConfirmationDialog.Resume.Body", {
        examName: this.state.examination.name,
      }),
      async () => {
        try {
          await CamplaCoreService.resumeExamination(this.state.examination._id);
          this.setState({ dialogApiError: "", showConfirmationDialog: false });
        } catch (err) {
          //Todo: Add correct errors according to documentation
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t
            ),
          });
        }
      },
      "green"
    );
  }

  async handleRetry() {
    try {
      await CamplaCoreService.RetryExaminationAction(
        this.state.examination._id
      );
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequest",
          },
          this.props.t
        ),
      });
    }
  }

  async handleExport(exportType, format, type = null) {
    try {
      switch (exportType) {
        case 1:
          await CamplaCoreService.downloadExaminationAttendanceList(
            this.state.examination._id,
            format,
            `Attendance-List-${this.state.examination.name
              .trim()
              .replace(" ", "_")}.${format}`
          );
          break;
        default:
          await CamplaCoreService.downloadExaminationPinCodes(
            this.state.examination._id,
            format,
            `PIN-Codes-${this.state.examination.name
              .trim()
              .replace(" ", "_")}.${format}`,
            type
          );
      }
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequest",
          },
          this.props.t
        ),
      });
    }
  }

  async handleDownloadSubmissions() {
    const filename = `Submissions-${this.state.examination.name
      .trim()
      .replace(" ", "_")}.zip`;
    try {
      this.setState({
        runningDownloadDialogShow: true,
        runningDownloadDialogTitle: filename,
        runningDownloadDialogProgress: 0,
      });
      await CamplaCoreService.downloadExaminationSubmissions(
        this.state.examination._id,
        filename,
        (percentage) =>
          this.setState({ runningDownloadDialogProgress: percentage })
      );
      this.setState({
        runningDownloadDialogShow: false,
        runningDownloadDialogTitle: "",
        runningDownloadDialogProgress: 0,
      });
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        runningDownloadDialogShow: false,
        runningDownloadDialogTitle: "",
        runningDownloadDialogProgress: 0,
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequest",
          },
          this.props.t
        ),
      });
    }
  }

  handleEdit() {
    this.setState({ showUpdateExaminationDialog: true });
  }

  async handleUpdateExamination(examination) {
    try {
      const updatedExamination = await CamplaCoreService.updateExamination(
        this.state.examination._id,
        examination
      );
      const clonedExamination = Object.assign({}, this.state.examination);
      for (const key in examination) {
        clonedExamination[key] = updatedExamination[key];
      }
      StorageService.set("singleExamination", clonedExamination);
      this.setState({
        examination: clonedExamination,
        showUpdateExaminationDialog: false,
      });
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
            NOT_FOUND: "Examinations.APIError.NotFound",
            BAD_REQUEST: "Examinations.APIError.BadRequest",
          },
          this.props.t
        ),
      });
    }
  }

  handleDelete() {
    const { t } = this.props;

    this.setActionConfirmationState(
      t("Examinations.ConfirmationDialog.Delete.Title"),
      t("Examinations.ConfirmationDialog.Delete.Body", {
        examName: this.state.examination.name,
      }),
      async () => {
        try {
          await CamplaCoreService.deleteExamination(this.state.examination._id);
          window.location.href = "./";
        } catch (err) {
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED: "Examinations.APIError.PreconditionFailed",
                NOT_FOUND: "Examinations.APIError.NotFound",
                BAD_REQUEST: "Examinations.APIError.BadRequest",
              },
              t
            ),
          });
        }
      },
      "red"
    );
  }

  async handleRejectProposal(studentFileId) {
    const { t } = this.props;

    try {
      await CamplaCoreService.rejectStudentFile(studentFileId);
      this.setState({
        studentFileProposals: [
          ...this.state.studentFileProposals.filter(
            (s) => s._id !== studentFileId
          ),
        ],
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleExamination.StudentFileProposalsTab.APIError.PreconditionFailed",
            NOT_FOUND: "",
            SERVER_ERROR: "",
          },
          t
        ),
      });
    }
  }

  async handleAcceptProposal(studentFileId) {
    const { t } = this.props;
    try {
      await CamplaCoreService.acceptStudentFile(studentFileId);
      const proposal = this.state.studentFileProposals.filter(
        (p) => p._id === studentFileId
      )[0];
      const index = this.state.studentFileProposals.indexOf(proposal);
      const updatedStudentFileProposal = Object.assign(
        {},
        this.state.studentFileProposals[index]
      );
      updatedStudentFileProposal["isAccepted"] = true;
      const studentFileProposals = [...this.state.studentFileProposals];
      studentFileProposals[index] = updatedStudentFileProposal;
      this.setState({ studentFileProposals });
      return true;
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleExamination.StudentFileProposalsTab.APIError.PreconditionFailed",
            NOT_FOUND: "",
            SERVER_ERROR: "",
          },
          t
        ),
      });
    }
    return false;
  }

  async handleUpdateConfiguration() {
    try {
      await CamplaCoreService.updateExaminationConfiguration(
        this.props.examination._id,
        { configuration: this.state.configuration }
      );
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  handleAdditionalInformation(text, title) {
    this.setState({
      showMarkdownViewerDialog: true,
      selectedMarkdownViewerText: text,
      selectedMarkdownViewerTitle: title,
    });
  }

  setActionConfirmationState(title, body, submitFunction, submitButtonVariant) {
    this.setState({
      showConfirmationDialog: true,
      examinationToDeleteOrEdit: this.state.examination,
      confirmationDialogTitle: title,
      confirmationDialogBody: body,
      onConfirmationDialogSubmit: submitFunction,
      confirmationDialogRightButtonVariant: submitButtonVariant,
      confirmationDialogLeftButtonVariant: "black",
    });
  }

  renderStudentFileProposalsTabTitle() {
    const { t } = this.props;
    const openSubmissions = this.state.studentFileProposals.filter(
      (p) => !p.isAccepted
    );
    return (
      <div>
        {t("SingleExamination.StudentFileProposalsTabTitle")}
        {openSubmissions.length > 0 && (
          <Badge variant="danger" className="ml-1">
            {" "}
            {openSubmissions.length}
          </Badge>
        )}
      </div>
    );
  }

  render() {
    const { t } = this.props;

    let instanceTemplateConfiguration = null;
    if (
      this.state.examination &&
      this.state.examination.instanceTemplate &&
      typeof this.state.examination.instanceTemplate["configuration"] !==
        "undefined" &&
      this.state.examination.instanceTemplate["configuration"]
    ) {
      try {
        instanceTemplateConfiguration = JSON.parse(
          atob(this.state.examination.instanceTemplate["configuration"])
        );
      } catch (err) {
        console.error(err);
      }
    }

    return !this.state.examination ? (
      <div />
    ) : (
      <div>
        <OpenExamAndAcceptSubmissionsDialog
          open={this.state.open}
          studentFileProposals={this.state.studentFileProposals}
          title={this.state.confirmationDialogTitle}
          body={this.state.confirmationDialogBody}
          show={this.state.showConfirmationDialog}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              showConfirmationDialog: false,
              open: false,
            })
          }
          onSubmit={this.state.onConfirmationDialogSubmit}
          confirmButtonVariant={this.state.confirmationDialogRightButtonVariant}
          cancelButtonVariant={this.state.confirmationDialogLeftButtonVariant}
          rightButtonText={t("SingleExamination.ConfirmationDialog.Confirm")}
          onAcceptProposal={async (studentFileId) =>
            this.handleAcceptProposal(studentFileId)
          }
        />
        <MarkdownViewerDialog
          show={this.state.showMarkdownViewerDialog}
          onHide={() => this.setState({ showMarkdownViewerDialog: false })}
          title={this.state.selectedMarkdownViewerTitle}
          text={this.state.selectedMarkdownViewerText}
          lang={this.props.i18n.language}
        />
        <UpdateExaminationDialog
          show={this.state.showUpdateExaminationDialog}
          examination={this.state.examination}
          onSubmit={this.handleUpdateExamination}
          onHide={() => this.setState({ showUpdateExaminationDialog: false })}
          dialogApiError={this.state.dialogApiError}
        />
        <RunningDownloadDialog
          show={this.state.runningDownloadDialogShow}
          onHide={() => this.setState({ runningDownloadDialogShow: false })}
          title={this.state.runningDownloadDialogTitle}
          progress={this.state.runningDownloadDialogProgress}
        />
        <Container className="mt-3">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <ExaminationInfoCard
            t={this.props.t}
            tReady={this.props.tReady}
            onOpen={this.handleOpen}
            onClose={this.handleClose}
            onPause={this.handlePause}
            onResume={this.handleResume}
            onRetry={this.handleRetry}
            onExport={this.handleExport}
            onEdit={this.handleEdit}
            onDelete={this.handleDelete}
            onAdditionalInformation={this.handleAdditionalInformation}
            onDownloadSubmissions={this.handleDownloadSubmissions}
            examination={this.state.examination}
          />
          <Row>
            <Col>
              <Tabs defaultActiveKey="instances">
                <Tab
                  eventKey="instances"
                  tabClassName="item-link"
                  title={t("SingleExamination.InstancesTabTitle")}
                >
                  <InstancesTab examination={this.state.examination} />
                </Tab>
                {this.state.examination &&
                typeof this.state.examination.instanceTemplate["type"] !==
                  "undefined" &&
                (this.state.examination.instanceTemplate.type === 0 ||
                  (instanceTemplateConfiguration &&
                    this.state.examination.securityLevel !== 5 &&
                    this.state.examination.securityLevel !== 6 &&
                    typeof instanceTemplateConfiguration.static[
                      "enable_smb_share"
                    ] !== "undefined" &&
                    instanceTemplateConfiguration.static.enable_smb_share)) ? (
                  <Tab
                    eventKey="examinationFiles"
                    tabClassName="item-link"
                    title={t("SingleExamination.ExaminationFilesTabTitle")}
                  >
                    <ExaminationFilesTab examination={this.state.examination} />
                  </Tab>
                ) : (
                  ""
                )}
                {this.state.examination &&
                typeof this.state.examination.instanceTemplate["type"] !==
                  "undefined" &&
                (this.state.examination.instanceTemplate.type === 0 ||
                  (instanceTemplateConfiguration &&
                    this.state.examination.securityLevel !== 5 &&
                    this.state.examination.securityLevel !== 6 &&
                    typeof instanceTemplateConfiguration.static[
                      "enable_smb_share"
                    ] !== "undefined" &&
                    instanceTemplateConfiguration.static.enable_smb_share)) ? (
                  <Tab
                    eventKey="studentFileProposals"
                    tabClassName="item-link"
                    title={this.renderStudentFileProposalsTabTitle()}
                  >
                    <StudentFileProposals
                      examination={this.state.examination}
                      studentFileProposals={this.state.studentFileProposals}
                      dialogApiError={this.state.dialogApiError}
                      onRejectProposal={async (studentFileId) =>
                        this.handleRejectProposal(studentFileId)
                      }
                      onAcceptProposal={async (studentFileId) =>
                        this.handleAcceptProposal(studentFileId)
                      }
                    />
                  </Tab>
                ) : (
                  ""
                )}
                {this.state.examination ? (
                  <Tab
                    eventKey="configuration"
                    tabClassName="item-link"
                    title={t("SingleExamination.ConfigurationTabTitle")}
                  >
                    <ConfigurationTab
                      onSubmit={this.handleUpdateConfiguration}
                      onFetchData={this.fetchData}
                      examination={this.state.examination}
                      instanceTemplateConfig={
                        this.state.examination.instanceTemplate.configuration
                      }
                    />
                  </Tab>
                ) : (
                  ""
                )}
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(SingleExamination);
